<div class="fixActionRow">
  <h1 mat-dialog-title>{{ title }}</h1>
  <div mat-dialog-content>
    @if (fileRead) {
      <div>
        @if (data.viewType === 1) {
          <div style="height: 440px;">
            <iframe
              [attr.src]="fileUrl"
              type="application/pdf"
              style="height: 425px; width: 500px;"
              title="File Reader"
            ></iframe>
          </div>
        }
        @if (data.viewType === 2) {
          <div>
            <img
              src="{{fileUrl}}"
        style="
          -webkit-transition: 0.5s ease-in-out;
          -moz-transition: 0.5s ease-in-out;
          -o-transition: 0.5s ease-in-out;
          transition: 0.5s ease-in-out;"
              [style.width.%]="imageWidth"
              [style.transform]="imageTransform"
              alt="File Image Viewer"
              />
            </div>
          }
        </div>
      }
    </div>
    <div mat-dialog-actions style="display: flex; justify-content: flex-end;">
      @if (data.viewType === 2) {
        <div style="margin: 18px 0 0 0">
          <button mat-stroked-button (click)="zoomInImage()">+</button>&nbsp;
          <button mat-stroked-button (click)="zoomOutImage()">-</button>&nbsp;
          <button mat-stroked-button (click)="rotateImage()">
            <mat-icon aria-hidden="false" aria-label="Example home icon"
              >rotate_right</mat-icon
              >
            </button>
          </div>
        }
        <div style="margin: 18px 0 0 18px;">
          <button mat-raised-button color="primary" (click)="onClickCancel()">DONE</button>
        </div>
      </div>
